import { FC } from 'react'
import Link from 'next/link'
import { Text, Icon } from '@/client/components'
import * as S from './styles'

export const Questions: FC<any> = ({ email, phone, contact_us_description, contact_us_title }) => (
  <S.SocialWrapper>
    <Text as='p' className='question-header' size='xlg' weight='bold' style={{ margin: '0' }}>
      {contact_us_title}
    </Text>
    <Text as='p' size='sm' className='socialmedia-help' family='text'>
      {contact_us_description}
    </Text>
    <Link href={`tel:${phone}`} passHref legacyBehavior>
      <Text size='md' margin='2rem 0 0' family='text' color='primary' font-weight='bold' className='social-media-text'>
        <Icon name='blue-phone' size='s4' className='social-media' />
        {phone}
      </Text>
    </Link>

    <Link href={`mailto:${email}`} passHref legacyBehavior>
      <Text
        size='md'
        margin='0.5rem 0 0'
        family='text'
        color='primary'
        font-weight='bold'
        className='social-media-text'
      >
        <Icon name='blue-email' size='s4' className='social-media' />
        {email}
      </Text>
    </Link>
  </S.SocialWrapper>
)
